import { Logger } from '../../modules'
import { BaseCall } from '../BaseCall'
import { APIConfig } from '../interfaces'

let wordsCache: string[] = []

export class Profanity extends BaseCall {
	public async list(): Promise<string[]> {
		try {
			if (wordsCache.length) return wordsCache
			const response = await this.client.get<{ words: string[] }>(`/profanity/words`)
			const words = response.data?.words
			if (words?.length) wordsCache = words

			return wordsCache
		} catch (e) {
			Logger.error(e)
			return []
		}
	}

	public setConfig(config: APIConfig): void {
		this.setBaseUrl(config.API_SERVER)
	}
}
